import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFordComponent } from './simple-icons-ford.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFordComponent ],
    exports:      [ SimpleIconsFordComponent ],
    bootstrap:    []
})
export class SimpleIconsFordModule {}
